import {
    SET_USER_INFO,
    UNSET_USER_INFO,
} from '../types'

const initialState = {
    user: {
        roles: []
    },
    loggedIn: false
};

const userReducer = (state = initialState, action) => {
    switch (action.type) {
        case UNSET_USER_INFO:
            localStorage.removeItem('token')
            return {
                ...state,
                loggedIn: false,
                user: {}
            };
        case SET_USER_INFO:
            return {
                ...state,
                loggedIn: true,
                user: action.user
            };
        default:
            return state;
    }
};


export default userReducer;